import {StyleSheet, Pressable, View, Dimensions, Platform} from 'react-native';
import Styles from '../../Styles';
import Localized from 'src/constants/AppStrings';
import AVText from 'src/components/elements/AVText';
import {CampusLocationType} from 'src/types/CampusLocationTypes';
import FontAwesome5Pro from '../../icons/FontAwesomeIcon';
import {getDescriber} from './descriptors/campusComponents/DescriptorType';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

type ScanAndPayLocationViewProps = {
  location: CampusLocationType;
  isCoffeeMachine: boolean;
  onLocationClick: (
    machine: CampusLocationType,
    autoAdvanced?: boolean,
  ) => Promise<void>;
};

const width = Dimensions.get('window').width;

const {getScanAndPayTile, getScanAndPayTileIcon} = getDescriber();

const ScanAndPayLocationView = (props: ScanAndPayLocationViewProps) => {
  const renderScanIcon = () => {
    return (
      <View style={[styles.iconView, getScanAndPayTile().iconViewBackground]}>
        {getScanAndPayTileIcon(props.isCoffeeMachine)}
      </View>
    );
  };

  const renderTextContent = () => {
    return (
      <View
        style={[
          styles.textView,
          getScanAndPayTile().textView,
          Platform.OS === 'android' && {top: -Styles.Spacing.m1},
        ]}
      >
        <AVText
          accessibilityLabel={`LocationName${
            props.location.displayName ?? props.location.name
          }`}
          accessibilityRole="text"
          aria-label={`${
            props.location.displayName ?? props.location.name
          }, text`}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
          style={getScanAndPayTile().titleText}
        >
          {props.location.displayName ?? props.location.name}
        </AVText>
        <AVText
          accessibilityLabel={Localized.Labels.scan_product}
          accessibilityRole="text"
          aria-label={`${Localized.Labels.scan_product}, text`}
          numberOfLines={1}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm5}
          style={getScanAndPayTile().nameText}
        >
          {props.isCoffeeMachine
            ? Localized.Labels.coffee_machine
            : Localized.Labels.scan_product}
        </AVText>
      </View>
    );
  };
  return (
    <Pressable
      accessibilityHint={`Double tap to select ${
        props.location.displayName ?? props.location.name
      }`}
      style={[styles.container, getScanAndPayTile().rowSpace]}
      accessibilityRole="button"
      onPress={() => props.onLocationClick(props.location)}
      accessibilityLabel={`Location${
        props.location.displayName ?? props.location.name
      }`}
      accessible={true}
      aria-label={`Location${
        props.location.displayName ?? props.location.name
      }`}
      nativeID={`Location${props.location.displayName ?? props.location.name}`}
    >
      {renderScanIcon()}
      {renderTextContent()}
      <View style={styles.arrowView}>
        <FontAwesome5Pro
          accessibilityLabel="Right arrow icon"
          aria-label="Right arrow icon"
          name="chevron-right"
          color={Styles.Colors.PayLegacy.grayScaleBase03}
          size={Styles.Fonts.f3}
        />
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    marginHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
    width: width - (Styles.Spacing.m3 + Styles.Spacing.m2) * 2,
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: Styles.Spacing.m2,
    ...getLayoutDescriber().shadowStyles().shadow,
  },
  iconView: {
    borderRadius: Styles.Spacing.m2,
    justifyContent: 'center',
    alignItems: 'center',
  },
  textView: {
    marginRight: Styles.Spacing.m4,
    justifyContent: 'center',
  },
  titleTxt: {
    marginRight: Styles.Spacing.m6 - Styles.Fonts.f1,
    fontWeight: '700',
    color: Styles.black,
    fontFamily: Styles.FontFamily.robotoRegular,
    fontSize: getLayoutDescriber().bodyLargeFontSize(),
  },
  nameTxt: {
    fontFamily: Styles.FontFamily.robotoRegular,
    fontSize: getLayoutDescriber().bodyLargeFontSize(),
    color: Styles.black,
    marginRight: Styles.Spacing.m6 - Styles.Fonts.f1,
    fontWeight: '400',
  },
  arrowView: {
    justifyContent: 'center',
    alignItems: 'center',
    right: Styles.Spacing.m3,
    position: 'absolute',
  },
});

export default ScanAndPayLocationView;
